import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../teamschat-transcript-dialog.action';
import { TeamschatTranscriptDialogState } from '../teamschat-transcript-dialog.state';

import { ResetNav } from './reset-nav.action';

export function resetNavReducer(
    state: TeamschatTranscriptDialogState,
    _: PayloadAction<ActionType.COACHING_DETAIL__TCTD__RESET_NAV, ResetNav>,
): TeamschatTranscriptDialogState {
    try {
        return {
            ...state,
            willNavigate: false,
            navigateCmtId: undefined,
            navigateDraftId: undefined,
            cmtNotesFocus: state.focus,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
